import { Pipe, PipeTransform } from '@angular/core';
@Pipe({ name: 'DateFilter'})
export class DateFilter implements PipeTransform {
  transform(value: string): string {
    let ret: string = ('' + value).trim();
    if (value === undefined || value === null || ret === '00010101') {
      return '';
    } else {
      return (ret.length == 8) ? (ret.substr(0, 4) + '/' + ret.substr(4, 2) + '/' + ret.substr(6, 2)) : ret;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/pipes/date.pipe.ts